import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { darkBlue, lightGrey } from '@styles/colors'
import { FC } from 'react'
type EmployerFunctionProps = {
    title: string
    value?: string;
    bg: boolean
};

const EmployerFunction: FC<EmployerFunctionProps> = ({
    title, value, bg
}) => {
    return (
        <Stack
            width={value !== undefined ? '200px' : '100%'}
            direction='row'
            borderRadius={5}
            padding={2}
            bgcolor={bg ? lightGrey : ''}
            spacing={2}
            alignItems='start'
            justifyContent={value !== undefined ? 'space-between' : 'center'}
        >
            <Typography variant="subtitle2" sx={{ color: darkBlue }}>
                {title}
            </Typography>
            {value !== undefined && (
                <Typography variant="subtitle2" >
                    {value}
                </Typography>
            )}
        </Stack>
    )
}

export default EmployerFunction